import { Dialog, Typography } from 'mui/core';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import cx from 'classnames';

const PREFIX = 'Modal';

export const classes = {
  titlesBox: `${PREFIX}-titlesBox`,
  titles: `${PREFIX}-titles`,
  title: `${PREFIX}-title`,
  secondTitle: `${PREFIX}-secondTitle`,
};

// Use styled(Dialog) so styles target the Dialog root element rendered in the
// portal at <body> level. This replaces the previous Root+disablePortal
// approach which broke full-page overlay positioning.
const StyledDialog = styled(Dialog)(({ theme }) => ({
  // Do NOT override root-level styles (position, display, zIndex, etc.)
  // Dialog's root handles full-page overlay positioning internally.

  '& .MuiDialog-paper': {
    minWidth: 760,
  },

  [`& .${classes.titlesBox}`]: {
    textAlign: 'center',
    alignItems: 'center',
    padding: theme.spacing(3, 6, 3, 6),
    margin: 0,
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(6),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(4, 4, 0, 4),
    },
  },

  [`& .${classes.titles}`]: {
    // width: '100%',
  },

  [`& .${classes.title}`]: {
    fontSize: 36,
    fontWeight: 400,
    color: theme.colors.blue2,
  },

  [`& .${classes.secondTitle}`]: {
    fontSize: 15,
    fontWeight: 400,
    color: theme.colors.blue2,
  },
}));

const Modal = ({
                 title,
                 firstTitleStyle,
                 secondTitle,
                 secondTitleStyle,
                 handleClose,
                 children,
                 titleChildren,
                 titleChildrenStyle,
                 disableBackdropClick = false,
                 disableEscapeKeyDown = false,
                 classes: classesProp,
                 paperSx,
                 ...restProps
               }) => {
  const handleDialogClose = (event, reason) => {
    if (disableBackdropClick && reason === 'backdropClick') return;
    if (disableEscapeKeyDown && reason === 'escapeKeyDown') return;
    handleClose && handleClose(event, reason);
  };

  // MUI v9: PaperProps is removed, use slotProps.paper instead.
  const paperSlotProps = {
    ...(restProps.slotProps?.paper || {}),
    ...(paperSx ? { sx: { ...(restProps.slotProps?.paper?.sx || {}), ...paperSx } } : {}),
  };

  return (
    <StyledDialog
      scroll='paper'
      onClose={handleDialogClose}
      classes={classesProp}
      {...restProps}
      slotProps={{
        ...restProps.slotProps,
        ...(Object.keys(paperSlotProps).length > 0 ? { paper: paperSlotProps } : {}),
      }}
    >
      <div className={cx(classes.titlesBox, firstTitleStyle)}>
        <div className={cx(classes.titles, titleChildrenStyle)}>
          <Typography className={classes.title}>{title}</Typography>
          <Typography className={cx(classes.secondTitle, secondTitleStyle)}>
            {secondTitle}
          </Typography>
        </div>
        {titleChildren}
      </div>
      {children}
    </StyledDialog>
  );
};

Modal.propTypes = {
  title: PropTypes.string,
  secondTitle: PropTypes.string,
  children: PropTypes.node,
  titleChildren: PropTypes.node,
  handleClose: PropTypes.func,
  firstTitleStyle: PropTypes.string,
  secondTitleStyle: PropTypes.string,
  titleChildrenStyle: PropTypes.string,
  classes: PropTypes.object,
  paperSx: PropTypes.object,
};

export default Modal;
